var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"sticky inset-x-0 top-0 z-20",class:{'navbar-transparent': _vm.transparent}},[_vm._t("default",null,{"toggleMenu":_vm.toggleMenu,"isOpen":_vm.isOpen})],2)}
var staticRenderFns = []

export { render, staticRenderFns }